(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scentro-four-chooser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scentro-four-chooser')) {
    customElements.define('scentro-four-chooser', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          if (!form.reportValidity() || this.busy) return;
          this.busy = true;
          const button = form.querySelector('button');
          const status = form.querySelector('[data-status]');
          const messages = JSON.parse(this.querySelector('[data-messages]').textContent);
          const counts = new Map();
          form.querySelectorAll('select').forEach((select) => counts.set(select.value, (counts.get(select.value) || 0) + 1));
          const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
          button.disabled = true;
          status.textContent = messages.loading;
          const root = window.Shopify?.routes?.root || '/';
          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || messages.error);
            window.location.assign(root + 'discount/SCENTRO4?redirect=' + encodeURIComponent(root + 'cart'));
          } catch (error) {
            status.textContent = error.message || messages.error;
            button.disabled = false;
            this.busy = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
